/**
 * Created by roman.kupin on 11/10/2017.
 */


export const PREFIX = "[ACCOUNT_API]";

export const PROPERTY_STATISTICS_FETCH = `${PREFIX}.PropertiesStatistics`;
export const PROPERTY_STATISTICS_FETCH_SUCCESS = `${PROPERTY_STATISTICS_FETCH}Success`;
export const PROPERTY_STATISTICS_FETCH_ERROR = `${PROPERTY_STATISTICS_FETCH}Error`;

// WS1/WS2 dead-code (2026-06-04 #13): removed the `getOverview` + `getRandomPhotos`
// thunks + their OVERVIEW_FETCH*/RANDOM_PHOTOS_FETCH* constants + the empty
// getAdvocacyOverview/getAdvocacyGuestJourney stubs (#11/#12).
// WS2 Step 5.2b: removed the `getProperties` thunk + its PROPERTIES_FETCH* constants —
// it was NEVER dispatched (the apiData.properties slice was always [] and its only
// readers were the now-deleted user.js block + singlePropertyContext), so the slice +
// reducer are gone too. Only getPropertiesStatistics remains (dispatched by the
// cooperative big-picture thunk).

export function getPropertiesStatistics(companyUUID, startDate, endDate) {
    return (dispatch, getState, {$http, environment}) => {
        dispatch({type: PROPERTY_STATISTICS_FETCH});
        return $http.get(`${environment.apiBaseUrl}/${companyUUID}/companies/${companyUUID}/properties/statistics?StartDate=${startDate}&EndDate=${endDate}`)
            .then(response => {
                dispatch({type: PROPERTY_STATISTICS_FETCH_SUCCESS, payload: response.data});
            }, error => {
                dispatch({type: PROPERTY_STATISTICS_FETCH_ERROR, payload: error});
                throw PROPERTY_STATISTICS_FETCH_ERROR;
            })
    }
}


const All = {getPropertiesStatistics};
export default All;
